import { Subject } from 'rxjs';

import createLegacyShimStream from './LegacyShim/Streams/createLegacyShimStream';

class ConsumerOutput {
    playerInteractions$ = new Subject();

    constructor(player, errors$) {
        const { playback, frame, media } = player.state.stores;

        this.legacyShim$ = createLegacyShimStream(
            frame.update$,
            media.update$,
            playback.update$,
            errors$
        );
    }
}

export default ConsumerOutput;
